<template>
    <v-select
        solo
        multiple
        v-bind:label="label"
        v-bind:items="items"
        v-bind:value="value"
        v-on:change="$emit('input', $event)"
    >
        <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle">
                <v-list-item-action>
                    <v-icon
                        v-bind:color="
                            value && value.length > 0 ? 'indigo darken-4' : ''
                        "
                        >{{ icon }}</v-icon
                    >
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>
        <template v-slot:selection="{ item, index }">
            <template v-if="index == 0">
                <span class="text--secondary">{{
                    isAllSelected ? 'All statuses' : 'Multiple'
                }}</span>
            </template>
        </template>
    </v-select>
</template>

<script>
export default {
    props: {
        // Example item: { text: 'Newest', value: 'created_at:desc' }
        items: Array,
        value: Array,
        label: String
    },
    computed: {
        isAllSelected() {
            return this.value && this.value.length == this.items.length;
        },
        isOnlySomeSelected() {
            return this.value && this.value.length > 0 && !this.isAllSelected;
        },
        icon() {
            if (this.isAllSelected) return 'mdi-close-box';
            if (this.isOnlySomeSelected) return 'mdi-minus-box';
            return 'mdi-checkbox-blank-outline';
        }
    },
    methods: {
        toggle() {
            this.$nextTick(() => {
                if (this.isAllSelected) {
                    this.$emit('input', []);
                } else {
                    this.$emit(
                        'input',
                        this.items.map(i => i.value)
                    );
                }
            });
        }
    }
};
</script>
